import { Link, type LinkProps } from 'react-router';

export type LinkButtonProps = LinkProps & {
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'md';
  className?: string;
};

const VARIANTS: Record<NonNullable<LinkButtonProps['variant']>, string> = {
  primary: 'bg-panda-500 text-ink-950 font-semibold hover:shadow-glow-panda hover:brightness-110',
  secondary:
    'bg-ink-700 text-ink-100 border border-ink-600 hover:border-panda-500/60 hover:shadow-glow-panda',
};

const SIZES: Record<NonNullable<LinkButtonProps['size']>, string> = {
  sm: 'h-9 px-4 text-sm gap-1.5',
  md: 'h-11 px-5 text-base gap-2', // 44px → cible tactile OK
};

/**
 * Lien react-router habillé comme un `Button` du design system (pill,
 * font-display, halo au hover). Sémantique correcte : c'est une NAVIGATION,
 * donc un `<a>` — pas un `<button>` imbriqué dans un lien.
 */
export function LinkButton({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}: LinkButtonProps) {
  return (
    <Link
      className={[
        'inline-flex select-none items-center justify-center rounded-full font-display',
        'transition-[box-shadow,filter,background-color,border-color] duration-fast ease-fun',
        VARIANTS[variant],
        SIZES[size],
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </Link>
  );
}
